import { render, staticRenderFns } from "./SiteBin.vue?vue&type=template&id=0c88f2b3&"
import script from "./SiteBin.vue?vue&type=script&lang=js&"
export * from "./SiteBin.vue?vue&type=script&lang=js&"
import style0 from "./SiteBin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports